import * as RadioPrimitive from '@radix-ui/react-radio-group';
import { useId } from 'react';
import { RadioField } from '../RadioField/RadioField';
import { TextFieldProps } from '../TextField/TextField';
import { Selector } from './Selector';

type SingleSelectProps = RadioPrimitive.RadioGroupItemProps & {
  body: string | React.ReactNode;
  header?: string;
  disabled?: boolean;
  freeText?: TextFieldProps;
};

export const SingleSelect = ({
  disabled = false,
  value,
  required,
  header,
  body,
  freeText,
  onClick,
  ...props
}: SingleSelectProps) => {
  const id = useId();

  return (
    <Selector
      disabled={disabled}
      header={header}
      body={body}
      childId={id}
      freeText={freeText}
    >
      <div className="mb-auto mt-[2px]">
        <RadioField
          {...props}
          id={id}
          aria-disabled={disabled}
          disabled={disabled}
          value={value}
          required={required}
          parentHandlesInteraction
          onClick={disabled ? (e) => e.preventDefault() : onClick}
        />
      </div>
    </Selector>
  );
};
